import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import fitVids from "fitvids";
import LazyLoad from "vanilla-lazyload";

const Common = {
  lazyLoad: null,
  prev_arrow:
    '<button class="slick-prev" aria-label="prev"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="34.063" viewBox="0 0 18 34.063"><defs><clipPath><rect width="18" height="34.063"/></clipPath></defs><g class="b" transform="translate(0 0)"><path class="c" d="M2.333,17.031,17.716,1.647A.964.964,0,1,0,16.353.284L.284,16.353a.961.961,0,0,0,0,1.363L16.353,33.778a.968.968,0,0,0,.678.285.941.941,0,0,0,.678-.285.961.961,0,0,0,0-1.363Z" transform="translate(0 0)"/></g></svg></button>',

  next_arrow:
    '<button class="slick-next" aria-label="next"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="34.076" viewBox="0 0 18 34.076"><defs><clipPath><rect width="18" height="34.075"/></clipPath></defs><g class="b"><path class="c" d="M17.722,16.359,1.648.284A.965.965,0,0,0,.284,1.648L15.673,17.037.284,32.426a.961.961,0,0,0,0,1.364.97.97,0,0,0,.678.286.94.94,0,0,0,.678-.286L17.715,17.715A.959.959,0,0,0,17.722,16.359Z"/></g></svg></button>',

  init: function () {
    Common.events();
    Common.photoswipe();
    Common.scroll.init();
    Common.accordions.init();
  },

  photoswipe: function () {
    if ($(".gallery").length) {
      $.ajax({
        url: ajaxurl,
        data: {
          action: "photoswipe",
        },
        type: "POST",
        dataType: "JSON",
        success: function (response) {
          $(".main").append(response);
          Common.gallery();
        },
      });
    }
  },

  events: function () {
    this.lazyLoad = new LazyLoad({
      elements_selector: ".lazy",
    });

    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Fitvids
    fitVids(".entry-content");
  },

  gallery: function () {
    $(".gallery").each(function (index) {
      var gallery_dom = $(this);
      var id = index;

      // Construct images array
      var items = [];
      gallery_dom.find(".gallery__item").each(function () {
        var img = $(this).find("img");
        items.push({
          src: img.attr("src"),
          w: img.attr("width"),
          h: img.attr("height"),
        });
      });

      // Init slider
      var slider = gallery_dom
        .find(".gallery__slider")
        .slick({
          infinite: false,
          slidesToShow: 1,
          prevArrow: Common.prev_arrow,
          nextArrow: Common.next_arrow,
        })
        .append(
          '<div class="gallery__expand"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"> <path fill="#7FB201" fill-rule="evenodd" d="M5.21002615,10.8800171 C5.60105933,10.9029154 5.90564828,11.2280711 5.9029837,11.6197651 C5.90031911,12.0114591 5.59133466,12.3324408 5.20002615,12.3500171 L0.720026154,12.3500171 C0.317781226,12.3423575 -0.00333546862,12.0123209 2.61539421e-05,11.6100171 L2.61539421e-05,7.14001708 C0.00181248189,6.87742687 0.143553326,6.63573651 0.371856281,6.50598841 C0.600159236,6.37624031 0.880339654,6.3781463 1.10685628,6.51098841 C1.33337291,6.64383052 1.47181248,6.88742687 1.47002615,7.15001708 C1.46002615,8.05001708 1.46002615,8.95001708 1.46002615,9.85001708 L4.63002615,6.68001708 C4.92034211,6.41241072 5.37009858,6.42156034 5.64929073,6.7007525 C5.92848289,6.97994466 5.93763252,7.42970112 5.67002615,7.72001708 C4.62002615,8.77001708 3.56002615,9.83001708 2.50002615,10.8800171 L5.21002615,10.8800171 Z M7.15002615,1.70804299e-05 L11.6200262,1.70804294e-05 C12.0241235,0.00708545561 12.3484561,0.335861004 12.3500262,0.74001708 L12.3500262,5.21001708 C12.3271278,5.60105025 12.0019721,5.90563921 11.6102781,5.90297462 C11.2185842,5.90031004 10.8976025,5.59132559 10.8800262,5.20001708 L10.8800262,2.50001708 C9.83002615,3.56001708 8.77002615,4.61001708 7.72002615,5.67001708 C7.42971019,5.93762345 6.97995373,5.92847382 6.70076157,5.64928166 C6.42156941,5.3700895 6.41241979,4.92033304 6.68002615,4.63001708 L9.84002615,1.47001708 L7.14002615,1.47001708 C6.87743595,1.46823075 6.63574558,1.32648991 6.50599748,1.09818695 C6.37624938,0.869883998 6.37815537,0.589703581 6.51099748,0.363186953 C6.64383959,0.136670326 6.88743595,-0.00176924752 7.15002615,1.70804299e-05 Z"/></svg></div><div class="gallery__status"><span class="gallery__status__current">1</span> / ' +
          items.length +
          "</div>"
        );

      // Change slide num
      slider.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          gallery_dom.find(".gallery__status__current").text(nextSlide + 1);
        }
      );

      // Expand image on click
      gallery_dom.on("click", ".gallery__item", function () {
        var current = parseInt($(this).data("item"));

        var options = {
          index: current,
          maxSpreadZoom: 1,
          getDoubleTapZoom: function (isMouseClick, item) {
            return item.initialZoomLevel;
          },
          closeOnScroll: false,
          history: false,

          // Size of top & bottom bars in pixels,
          barsSize: {
            top: 44,
            bottom: 0,
          },

          // Buttons/elements
          zoomEl: false,
          shareEl: false,
          counterEl: false,

          // Tap on sliding area should close gallery
          tapToClose: true,

          // Tap should toggle visibility of controls
          tapToToggleControls: false,

          // Mouse click on image should close the gallery,
          clickToCloseNonZoomable: false,

          // Element classes click on which should close the PhotoSwipe.
          closeElClasses: ["item", "caption", "zoom-wrap", "ui"],
        };

        var pswpElement = document.querySelectorAll(".pswp")[0];

        var gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          items,
          options
        );
        gallery.init();
      });

      // Expand image on Expand click
      gallery_dom.on("click", ".gallery__expand", function () {
        gallery_dom.find(".slick-current .gallery__item").click();
      });
    });
  },

  scroll: {
    sticky: false,
    topbar: false,
    last: 0,

    init: function () {
      Common.scroll.do();
      $(window).scroll(function () {
        Common.scroll.do();
      });
    },

    do: function () {
      var st = $(window).scrollTop();

      if (st > 110 && !Common.scroll.sticky) {
        Common.scroll.sticky = true;
        $(".header").addClass("header--scrolled");
      } else if (st < 110 && Common.scroll.sticky) {
        Common.scroll.sticky = false;
        $(".header").removeClass("header--scrolled");
      }

      Common.scroll.last = st;
    },
  },
  accordions: {
    init: function () {
      var header = "accordion__header";
      var header_class = "." + header;
      var header_active = header + "--open";

      $("body").on("click", header_class, function () {
        var btn = $(this);
        var siblings = btn.parent().siblings();

        // Show content
        btn.next().slideToggle(250);

        // Close siblings
        siblings.children(header_class).removeClass(header_active);
        siblings.children(".accordion__body").slideUp(250);

        // Scroll to dropdown
        if (!btn.hasClass(header_active)) {
          setTimeout(function () {
            var scrollTo = btn.offset().top - $(".main").offset().top;
            $("html, body").animate(
              {
                scrollTop: scrollTo - $(".header").height() - 20,
              },
              250
            );
          }, 250);
        }

        // Animate header
        btn.toggleClass(header_active);
      });
    }
  },
};
export default Common;
